// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__YTzSu","actions":"GroupTable_actions__1sIAc","deleteModalFooter":"GroupTable_deleteModalFooter__5BqaW"};